module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/2_img@3x-6f53f700e97c75f5571679a680f31bd4.png";